export const OverlayTrigger = ({
  children,
}: {
  children?: React.ReactNode
}) => {
  return children
}
